export default "__VITE_ASSET__ByJk00AF__"